import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserModel } from "../shared/models/user-model";
import { BaseService } from "./base.service";

@Injectable()
export class AuthenticationService extends BaseService {
  constructor(
    public http: HttpClient //  public local: Location
  ) {
    super(http);
  } 
  public Login(data: UserModel) {
    let value = {
      username: data.username.toLocaleLowerCase(),
      password: data.password      
    };    
    return this.Post("login", value, false);
  }    
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts